import { Module } from 'vuex'

interface ReviewPostPageState {
  isFirstOpendPage: boolean
  entrySummaryExpandedList: { [entryId: string]: boolean }
  entrySelectedReviewIndexList: { [entryId: string]: number }
  entryEditingList: { [entryId: string]: boolean }
}

export const reviewPostPageStateModule = (): Module<ReviewPostPageState, any> => {
  return {
    namespaced: true,
    state: {
      isFirstOpendPage: true,
      entrySummaryExpandedList: {},
      entrySelectedReviewIndexList: {},
      entryEditingList: {}
    },
    mutations: {
      setIsFirstOpendPage(state, { flag }: { flag: boolean }) {
        state.isFirstOpendPage = flag
      },
      setEntrySummaryExpandedList(state, { list }: { list: { [entryId: string]: boolean } }) {
        state.entrySummaryExpandedList = list
      },
      setEntrySelectedReviewIndexList(state, { list }: { list: { [entryId: string]: number } }) {
        state.entrySelectedReviewIndexList = list
      },
      setEntrySummaryExpandedFlag(state, { entryId, flag }: { entryId: string; flag: boolean }) {
        state.entrySummaryExpandedList[entryId] = flag
      },
      setEntrySelectedReviewIndex(
        state,
        { entryId, selectedReviewIndex }: { entryId: string; selectedReviewIndex: number }
      ) {
        state.entrySelectedReviewIndexList[entryId] = selectedReviewIndex
      },
      setEntryEditingList(state, { list }: { list: { [entryId: string]: boolean } }) {
        state.entryEditingList = list
      },
      setEntryEditingFlag(state, { entryId, flag }: { entryId: string; flag: boolean }) {
        state.entryEditingList[entryId] = flag
      }
    },
    actions: {},
    getters: {
      isFirstOpendPage: state => state.isFirstOpendPage,
      entrySummaryExpandedList: state => state.entrySummaryExpandedList,
      entrySelectedReviewIndexList: state => state.entrySelectedReviewIndexList,
      entryEditingList: state => state.entryEditingList
    }
  }
}
